/**
 * 제출 관련 핸들러 함수들
 */
import { testStep1, testStep2 } from '@/apis/diagnostic';

/**
 * 제출 핸들러
 * @param {number} step - 제출할 단계 (1 또는 2)
 * @param {object} params - 필요한 상태 및 함수들
 */
// handleSubmit(step, { selectedProblem, selectedLines, modifiedCode, setSubmitResult });
export const handleSubmit = async (step, params) => {
    const {
        problemId,
        selectedLines,
        modifiedCode,
        setSubmitResult,
        setStep1TestPassed,
        setStep2TestPassed,
    } = params;

    if (step === 1) {
        try {
            const response = await testStep1(problemId, { answers: selectedLines });
            setSubmitResult(response);
            setStep1TestPassed(response.correct);
        } catch (error) {
            console.error('Error submitting secure training first:', error);
        }
    } else if (step === 2) {
        try {
            const response = await testStep2(problemId, {answers: modifiedCode});
            setSubmitResult(response);
            setStep2TestPassed(response.correct);
        } catch (error) {
            console.error('Error submitting secure training second:', error);
        }
    }
};
